module.exports = __webpack_public_path__ + "static/media/kids_27.81f02670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_27.jpg
// module id = 5883
// module chunks = 0